import BannerLiquidate from './BannerLiquidate';

export default BannerLiquidate;
